import React from 'react';
import PropTypes from 'prop-types';
import {
  Table,
  TableContainer,
} from '@material-ui/core';
import StreamingRankTable from './StreamingRankTable';
import SecondaryCreationTable from './SecondaryCreationTable';
import { isNewTypeQuestStart } from '../../../../../utils/functions';

const RankMode = ({
  fields,
  meta: { error },
  questForm,
  quest,
  autoStreamingQuest,
  secondaryCreationQuest
}) => {
  const isNew = !quest;
  const questStarted = React.useMemo(() => {
    if (!questForm?.values?.startDateTime || !quest) return false;
    return isNewTypeQuestStart(quest);
  }, [questForm?.values?.startDateTime, quest]);

  React.useEffect(() => {
    if ((!questForm?.values?.splitTiers || questForm?.values?.splitTiers.length === 0) && fields.length === 0) {
      const nextRankUpper = 1;
      
      const initialValues = autoStreamingQuest ? {
        prize: 0,
        watchTime: 0,
        rankLower: nextRankUpper,
        rankUpper: nextRankUpper,
      } : secondaryCreationQuest ? {
        prize: 0,
        minTotalViews: 0,
        rankLower: nextRankUpper,
        rankUpper: nextRankUpper,
      } : null;

      if (initialValues) {
        fields.push(initialValues);
      }
    }
  }, [fields, questForm?.values?.splitTiers, autoStreamingQuest, secondaryCreationQuest]);

  const handleAddNewTier = React.useCallback(() => {
    const rankTiers = questForm?.values?.rankTiers;
    let nextRankUpper = 1;

    if (rankTiers?.length > 0) {
      const lastTier = rankTiers[rankTiers.length - 1];
      nextRankUpper = parseInt(lastTier.rankLower) + 1 || 1;
    }

    const newTier = autoStreamingQuest ? {
      prize: 0,
      watchTime: 0,
      rankLower: nextRankUpper,
      rankUpper: nextRankUpper,
    } : secondaryCreationQuest ? {
      prize: 0,
      minTotalViews: 0,
      rankLower: nextRankUpper,
      rankUpper: nextRankUpper,
    } : null;

    if (newTier) {
      fields.push(newTier);
    }
  }, [fields, questForm?.values?.rankTiers, autoStreamingQuest, secondaryCreationQuest]);

  return (
    <section className="WhiteListWrapper">
      <TableContainer>
        <Table>
          {autoStreamingQuest && questForm?.values?.rankTiers?.length > 0 && (
            <StreamingRankTable
              fields={fields}
              questForm={questForm}
              questStarted={questStarted}
              isNew={isNew}
            />
          )}
          {secondaryCreationQuest && questForm?.values?.rankTiers?.length > 0 && (
            <SecondaryCreationTable
              fields={fields}
              questForm={questForm}
              questStarted={questStarted}
              isNew={isNew}
            />
          )}
        </Table>
      </TableContainer>
      {error && <span className="RepeaterWrapper__error">{error}</span>}
      <button 
        className="RepeaterWrapper__add-item" 
        type="button" 
        onClick={handleAddNewTier}
      >
        Add New Tier
      </button>
    </section>
  );
};

RankMode.propTypes = {
  fields: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
  questForm: PropTypes.object,
  quest: PropTypes.object,
  autoStreamingQuest: PropTypes.bool,
  secondaryCreationQuest: PropTypes.bool
};

export default React.memo(RankMode);